import React from 'react';

export default function DetailPenerbangan() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Detail Penerbangan</h1>
      <p className="text-gray-500">Halaman Detail Penerbangan</p>
    </div>
  );
}
